<div class="loader-backdrop">
  <div class="loading"></div>
</div>